/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AccountControllerDtoAccountCurrentPowerUpdateRequest model module.
 * @module model/AccountControllerDtoAccountCurrentPowerUpdateRequest
 * @version 1.0
 */
class AccountControllerDtoAccountCurrentPowerUpdateRequest {
    /**
     * Constructs a new <code>AccountControllerDtoAccountCurrentPowerUpdateRequest</code>.
     * @alias module:model/AccountControllerDtoAccountCurrentPowerUpdateRequest
     */
    constructor() { 
        
        AccountControllerDtoAccountCurrentPowerUpdateRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AccountControllerDtoAccountCurrentPowerUpdateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AccountControllerDtoAccountCurrentPowerUpdateRequest} obj Optional instance to populate.
     * @return {module:model/AccountControllerDtoAccountCurrentPowerUpdateRequest} The populated <code>AccountControllerDtoAccountCurrentPowerUpdateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AccountControllerDtoAccountCurrentPowerUpdateRequest();

            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('currentPower')) {
                obj['currentPower'] = ApiClient.convertToType(data['currentPower'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AccountControllerDtoAccountCurrentPowerUpdateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AccountControllerDtoAccountCurrentPowerUpdateRequest</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} accountNo
 */
AccountControllerDtoAccountCurrentPowerUpdateRequest.prototype['accountNo'] = undefined;

/**
 * @member {Number} currentPower
 */
AccountControllerDtoAccountCurrentPowerUpdateRequest.prototype['currentPower'] = undefined;






export default AccountControllerDtoAccountCurrentPowerUpdateRequest;

